import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Documents } from '../@types/UploadDocument'

type Store = {
  documents: Documents[]
  setDocument: (value: Documents[]) => void
  addDocument: (document: Documents) => void
  removeDocument: (id: string) => void
  resetDocuments: () => void
  resetInitialDocumentsState: () => void
  switchAttachment: { [key: string]: boolean }
  setSwitchAttachment: (value: { [key: string]: boolean }) => void
}

export const useDocumentStore = create<Store>()(
  devtools(
    (set) => ({
      documents: [],
      setDocument: (documents) => set({ documents }),
      addDocument: (_document) =>
        set((state) => ({
          documents: [...state.documents, _document],
        })),
      removeDocument: (id) =>
        set((state) => ({
          documents: state.documents.filter((doc) => doc.documentId !== id),
        })),
      resetDocuments: () => set({ documents: [] }),
      switchAttachment: {},
      setSwitchAttachment: (value) =>
        set((state) => ({
          switchAttachment: {
            ...state.switchAttachment,
            ...value,
          },
        })),
      resetInitialDocumentsState: () =>
        set({ documents: [], switchAttachment: {} }),
    }),
    { name: 'DocumentStore' },
  ),
)
